import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@utils/cn';

interface DateInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  helperText?: string;
}

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, label, error, helperText, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && <label className="input-label">{label}</label>}
        <input
          ref={ref}
          type="date"
          className={cn('input-base', error && 'input-error', className)}
          {...props}
        />
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        {helperText && !error && <p className="mt-1 text-sm text-gray-500">{helperText}</p>}
      </div>
    );
  }
);

DateInput.displayName = 'DateInput';

export default DateInput;
